import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiTextField from "@mui/material/TextField";
import MuiFormHelperText from "@mui/material/FormHelperText";
import MuiAutocomplete from "@mui/material/Autocomplete";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelHelperSrc from "../../model/HelperSrc";
import * as ModelTask from "../../model/custom/Task";
import ControllerLocalization from "../../controller/Localization";
import ControllerTaskProfile from "../../controller/custom/TaskProfile";
import ViewDatepicker from "../../view/Datepicker";
import ViewLoader from "../Loader";

let isRendered = false;
let isDisabled = false;

const viewPageTaskProfile: React.FC<ModelTask.Iprops> = (props) => {
    // Variable
    const controllerTaskProfile = new ControllerTaskProfile(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerTaskProfile.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain && controllerTaskProfile.getSelectOption && controllerTaskProfile.getValidationForm) {
        isDisabled = !HelperSrc.checkRole(controllerTaskProfile.getStorageRole, ["manager"], props.userData);

        return (
            <div className="view_task_profile form" data-at_id="view_task_profile">
                {(() => {
                    const html: JSX.Element[] = [];

                    if (controllerTaskProfile.getDataMain) {
                        html.push(
                            <div>
                                <div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_name"
                                            name="name"
                                            label={controllerLocalization.getStorageMain.name}
                                            defaultValue={controllerTaskProfile.getDataMain.name || ""}
                                            required={controllerTaskProfile.getValidationForm.name.required}
                                            onChange={(event) => {
                                                if (controllerTaskProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerTaskProfile.getValidationForm.name.regex_pattern,
                                                        controllerTaskProfile.getValidationForm.name.error_msg
                                                    );
                                                }
                                            }}
                                            disabled={isDisabled}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <ViewDatepicker
                                            id="input_day"
                                            fieldMode="datepicker_yearMonthDay"
                                            variant="outlined"
                                            className="field_value date"
                                            data-at_id="input_day"
                                            name="day"
                                            label={controllerLocalization.getStorageMain.day}
                                            defaultValue={controllerTaskProfile.getDataMain.day || ""}
                                            required={controllerTaskProfile.getValidationForm.day.required}
                                            onChange={(event) => {
                                                if (controllerTaskProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerTaskProfile.getValidationForm.day.regex_pattern,
                                                        controllerTaskProfile.getValidationForm.day.error_msg
                                                    );
                                                }
                                            }}
                                            disabled={isDisabled}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            multiline
                                            rows="4"
                                            variant="outlined"
                                            className="field_value field_textarea"
                                            data-at_id="input_description"
                                            name="description"
                                            label={controllerLocalization.getStorageMain.description}
                                            defaultValue={controllerTaskProfile.getDataMain.description || ""}
                                            required={controllerTaskProfile.getValidationForm.description.required}
                                            onChange={(event) => {
                                                if (controllerTaskProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerTaskProfile.getValidationForm.description.regex_pattern,
                                                        controllerTaskProfile.getValidationForm.description.error_msg
                                                    );
                                                }
                                            }}
                                            disabled={isDisabled}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiAutocomplete
                                            blurOnSelect
                                            options={(() => {
                                                const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                for (const optionData of Object.values(controllerTaskProfile.getSelectOption.member_id)) {
                                                    const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                    optionList.push(optionDataTyped);
                                                }

                                                return optionList;
                                            })()}
                                            getOptionLabel={(option) => option.display_name}
                                            value={(() => {
                                                const currentStr =
                                                    controllerTaskProfile.getElementMemberIdValue === "" && controllerTaskProfile.getDataMain
                                                        ? controllerTaskProfile.getDataMain.member_id
                                                        : controllerTaskProfile.getElementMemberIdValue;

                                                const opts = (() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];
                                                    for (const optionData of Object.values(controllerTaskProfile.getSelectOption.member_id)) {
                                                        optionList.push(optionData as ModelHelperSrc.IelementOption);
                                                    }
                                                    return optionList;
                                                })();

                                                const selected = opts.find((o) => String(o.value) === String(currentStr)) || opts[0];
                                                return selected;
                                            })()}
                                            renderOption={(props, option) => {
                                                if (controllerLocalization.getStorageMain) {
                                                    return (
                                                        <li {...props} data-at_id={`select_${option.display_name ? option.display_name : "select"}`}>
                                                            {option.display_name || controllerLocalization.getStorageMain.select}
                                                        </li>
                                                    );
                                                }
                                            }}
                                            isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                            renderInput={(params) => (
                                                <div>
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_member_id"
                                                        required={
                                                            controllerTaskProfile.getValidationForm
                                                                ? controllerTaskProfile.getValidationForm.member_id.required
                                                                : false
                                                        }
                                                        onChange={(event) => HelperSrc.checkRegexSelect(event.target.name, event.target.value)}
                                                        label={
                                                            controllerLocalization.getStorageMain ? controllerLocalization.getStorageMain.member : ""
                                                        }
                                                    />
                                                    <input
                                                        type="hidden"
                                                        className="field_value"
                                                        name="member_id"
                                                        defaultValue={
                                                            controllerTaskProfile.getElementMemberIdValue === "" && controllerTaskProfile.getDataMain
                                                                ? controllerTaskProfile.getDataMain.member_id !== undefined
                                                                    ? controllerTaskProfile.getDataMain.member_id
                                                                    : ""
                                                                : controllerTaskProfile.getElementMemberIdValue
                                                        }
                                                    />
                                                </div>
                                            )}
                                            onChange={(_, option) => {
                                                if (option && controllerTaskProfile.setElementMemberIdValue) {
                                                    controllerTaskProfile.setElementMemberIdValue(option.value as string);
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                </div>
                                <div className="bottom">
                                    <div className="button_container">
                                        <MuiButton
                                            className="button_primary"
                                            data-at_id="button_update"
                                            disabled={controllerTaskProfile.getApiLoadingList.profileChange || isDisabled}
                                            onClick={(event) => {
                                                controllerTaskProfile.clickChange(event);
                                            }}
                                        >
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                if (controllerTaskProfile.getApiLoadingList.profileChange) {
                                                    html.push(<MuiCircularProgress className="icon_progress" />);
                                                } else {
                                                    html.push(<>{controllerLocalization.getStorageMain.update}</>);
                                                }

                                                return html;
                                            })()}
                                        </MuiButton>
                                    </div>
                                </div>
                            </div>
                        );
                    }

                    return html;
                })()}
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageTaskProfile;
